import React from "react";
import { useQuery } from "@apollo/client";
import gql from "graphql-tag";

// Utils
import {
  GET_STRINGS_LOGIN,
  GET_STRINGS_PASSWORD,
  GET_STRINGS_PASSWORD_NEW,
  GET_STRINGS_REGISTER,
} from "../queries/Language.queries";
import { Language, LanguageStrings } from "../types/Language.types";

const QUERY_LANGUAGE_STRINGS = {
  login: gql`
    ${GET_STRINGS_LOGIN}
  `,
  password: gql`
    ${GET_STRINGS_PASSWORD}
  `,
  passwordNew: gql`
    ${GET_STRINGS_PASSWORD_NEW}
  `,
  register: gql`
    ${GET_STRINGS_REGISTER}
  `,
};

const useLanguageStrings = (
  countryCode: string,
  stringType: "login" | "password" | "passwordNew" | "register"
) => {
  const [strings, setStrings] = React.useState<LanguageStrings | null>(null);

  useQuery(QUERY_LANGUAGE_STRINGS[stringType], {
    onCompleted: (data) => {
      // Get All Language Settings
      const { languages } = data.spracheinstellungen.translationSettings;

      // Filter Language by passed CountryCode
      const filteredLanguage = languages.filter(
        (language: Language) => language.countryCode === countryCode
      )[0];

      setStrings(filteredLanguage.translationStrings);
    },
  });

  return [strings];
};

export default useLanguageStrings;
